<component :is="tag">{{ dateFiltered }}</component>